import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import styles from './GuidePage.scss'
import layout from '../layout.scss'
import cx from 'classnames'
import { GuidesList } from './GuidesList'
import { EditorColumn } from './EditorColumn'
import { getExperienceId } from '../ExperiencesApp/ExperiencesApp'
import { experienceActions, experienceSelectors } from 'data/resources/experiences'
import { experienceGuidePageActions, experienceGuidePageSelectors } from 'data/resources/experienceGuidePages'
import { experienceRoutesActions } from 'lib/api/experiences/routes'
import Helmet from 'react-helmet'

export class _GuidePage extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      expandedId: null
    }
  }

  componentDidMount () {
    const { loadExperience, loadGuides, loadRoutes } = this.props
    loadExperience()
    loadGuides()
    loadRoutes()
  }

  componentDidUpdate (prevProps) {
    const { loadExperience, loadGuides, loadRoutes } = this.props
    if (getExperienceId(prevProps) !== getExperienceId(this.props)) {
      loadExperience()
      loadGuides()
      loadRoutes()
    }
  }

  setExpanded = (id) => {
    this.setState({ expandedId: id })
  }

  render () {
    const { guides, experience } = this.props
    const { expandedId } = this.state
    const selectedGuide = expandedId ? guides.get(expandedId) : null

    return (
      <div className={cx(layout.container, styles.GuidePage)}>
        {experience && <Helmet title={experience.name} />}
        <div className={layout.mainColumn}>
          {guides && experience && <GuidesList
            experience={experience}
            guides={guides}
            expandedId={expandedId}
            setExpanded={this.setExpanded} />}
        </div>
        <div className={layout.editorColumn}>
          <EditorColumn guides={guides} selectedGuide={selectedGuide} />
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const experienceId = getExperienceId(ownProps)

  return {
    loadExperience: () => dispatch(experienceActions.read(experienceId)),
    loadGuides: () => dispatch(experienceGuidePageActions.list({ experienceId })),
    loadRoutes: () => dispatch(experienceRoutesActions.loadAll(experienceId))
  }
}

const mapStateToProps = (state, ownProps) => {
  const experienceId = getExperienceId(ownProps)

  return {
    experience: experienceSelectors.find(state, experienceId),
    guides: experienceGuidePageSelectors.byExperienceId(state, experienceId)
  }
}

export const GuidePage = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(_GuidePage))
